"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var form_item_1 = __importDefault(require("../form-item"));
var ReceiverRequirements_1 = require("../../types/ReceiverRequirements");
var antd_1 = require("antd");
var React = __importStar(require("react"));
var react_intl_1 = require("react-intl");
var translationMessages = react_intl_1.defineMessages({
    baseInformation_orderReferenceLabel: {
        id: "baseInformation_orderReferenceLabel",
        defaultMessage: "Order number"
    },
    baseInformation_orderReferenceLabel_helpText: {
        id: "baseInformation_orderReferenceLabel_helpText",
        defaultMessage: "Only use a reference to an actual order here. If no order exists, the buyer reference must be specified."
    },
});
var getOrderReferenceFieldDefinitions = function (receiverRequirements) {
    return receiverRequirements && receiverRequirements.fieldDefinitions.find(function (fieldRequirement) { return fieldRequirement.key === "orderReference.documentNo"; });
};
var OrderReference = function (props) {
    if (getOrderReferenceFieldDefinitions(props.receiverRequirements)) {
        var required = !(props.formInstance.getFieldValue(["invoice", "buyerReference"]));
        return React.createElement(form_item_1.default, { shouldUpdate: true, dependencies: props.dependencies, receiverRequirements: props.receiverRequirements, receiverRequirementsKey: ReceiverRequirements_1.AvailableFields["orderReference.documentNo"], defaultLabel: props.intl.formatMessage(translationMessages.baseInformation_orderReferenceLabel), defaultLabelTooltip: props.intl.formatMessage(translationMessages.baseInformation_orderReferenceLabel_helpText), defaultIsRequired: required, fieldName: ["invoice", "orderReference", "documentNo"] },
            React.createElement(antd_1.Input, null));
    }
    else {
        return null;
    }
};
exports.default = react_intl_1.injectIntl(OrderReference);
